import PocketBase from "pocketbase";

// Create PocketBase instance
// const pb = new PocketBase("https://pocket.alphasoft.world");
const pb = new PocketBase("https://backend.alphasoft.website");

// Disable auto-cancellation for better request handling
pb.autoCancellation(false);

// Simple auth helper methods
pb.ensureAuth = async () => {
  if (!pb.authStore.isValid) {
    throw new Error("Authentication required");
  }
  return pb.authStore.model;
};

// Add auth to every request automatically
pb.beforeSend = function (url, options) {
  if (pb.authStore.token) {
    options.headers = options.headers || {};
    options.headers['Authorization'] = pb.authStore.token;
  }
  return { url, options };
};

// Current user info (for debugging/display purposes)
const currentUser = pb.authStore.model?.username || pb.authStore.model?.email || "Guest";
const currentDateTime = new Date().toISOString();

export default pb;